<template>
  <mks-spacer spacing="xl">
    <mks-heading tag="h2" tag-class="h3">{{ __('Les infos essentielles') }}</mks-heading>
    
    <Info :title="__('Langue de l\'événment')" v-if="lang !== 'fr'">
      <mks-spacer spacing="xs" align="center" inline>
        <img
          :src="languages[event.lang].icon"
          class="event__flag"
          aria-hidden
        />
        <mks-text tag="span">{{languages[event.lang].text}}</mks-text>
      </mks-spacer>
    </Info>
    <Info :title="__('Où se passe l\'événement')">
      <mks-text v-if="event.visio" size="small"
        ><mks-icon type="video" size="15"></mks-icon> {{__("Cet événement est par vidéo-conférence. L'organisateur vous communiquera par email le lien vous permettant de vous connecter !")}}</mks-text
      >
      <template v-else>
        <mks-text size="small" weight="semibold">
          <span v-if="event.address && event.address[lang].name && !event.address[lang].formattedAddress.includes(event.address[lang].name)">{{ event.address[lang].name }}, </span>{{ event.address[lang].formattedAddress }}
        </mks-text>
        <mks-text v-if="event.addressMore" size="small">
          {{ event.addressMore[lang] }}
        </mks-text>
      </template>
    </Info>
    <Info :title="__('Les organisateurs')">
      <mks-spacer inline v-for="u in users" :key="u.name" align="center" nowrap>
        <mks-avatar v-if="u.img" :image="u.img"></mks-avatar>
        <mks-avatar v-else :image="$getAvatarImage(Math.ceil(Math.random() * 8))"></mks-avatar>
        <mks-spacer-item class="organizer__name">
             <mks-text size="large" weight="semibold"
          >{{ u.name }}</mks-text
        >
        </mks-spacer-item>
        <mks-spacer-item push="right" v-if="!event.source">
          <mks-button size="round" type="neutral" @click="$emit('contact', u)"
            ><mks-icon type="mail" :alt="__('Contacter l\'organisateur')"></mks-icon></mks-button
          >
        </mks-spacer-item>
      </mks-spacer>
    </Info>
    <Info :title="__('Les participant.e.s')" v-if="!event.registerExternal && event.attendees.length > 0">
      <mks-spacer inline spacing="xxs" align="center">
        <div>
          <mks-avatar
            v-for="a in attendeesWithAvatar"
            :key="a._id"
            :image="a.user.profileImg.url"
            size="small"
            class="participant__avatar"
          ></mks-avatar>
        </div>
        <mks-text v-if="other > 0" size="small" weight="semibold" color="light"
          >{{_x('et ${other} autres...', 'Nombre de participants qui n\'ont pas d\'avatar', {other: other})}}</mks-text
        >
      </mks-spacer>
    </Info>
    <mks-spacer spacing="xxs">
      <mks-text tag="p" weight="bold">{{
        __("Invite un·e ami·e")
      }}</mks-text>
      <Share
        :url="`${event.url}?utm_source=events&utm_medium=share&utm_campaign=event-page`"
        :title="event.title[event.lang]"
        :description="
          event.description && event.description[event.lang] ? event.description[event.lang] : ''
        "
      />
    </mks-spacer>
    <div>
      <mks-text size="small" color="light">
        <a class="abuse-link" :href="abuseLink">{{
              __("Signaler un abus")
            }}</a></mks-text
          >
    </div>
  </mks-spacer>
</template>
<script>
import Info from '@/components/molecules/Info.vue'
export default {
  components: {Info},
  props: {
    event: Object,
  },
  computed: {
    abuseLink() {
      return this._x(`mailto:${this.$env.supportEmail}`, 'Adresse email du support');
    },
    users() {
      if (this.event.source) {
        return [
          {
            img: this.event.source.user && this.event.source.user.logo ? this.event.source.user.logo : undefined,
            name: this.event.source.name && this.event.source.user.name ? this.event.source.user.name : undefined,
          }]
      } else {
        return this.event.user.map(u => {
          return {
            _id: u._id,
            img: u.profileImg ? u.profileImg.url : undefined,
            name: u.displayname || (u.firstName + ' ' + u.lastName),
          }
        })
      }
    },
    attendeesWithAvatar() {
      return this.event.attendees.filter((a) => a.user && a.user.profileImg).slice(0, 3);
    },
    other() {
      return this.event.attendees.length - this.attendeesWithAvatar.length;
    },
    lang() {
      return this.event.lang;
    },
    languages() {
        return {
          en: {
            icon: '/assets/images/flag-uk.png',
            text: this._x('Anglais', 'Langue de l\'événement')
          },
          es: {
            icon: '/assets/images/flag-spain.png',
            text: this._x('Espagnol', 'Langue de l\'événement')
          },
          fr: {
            icon: '/assets/images/flag-france.png',
            text: this._x('Français', 'Langue de l\'événement')
          }
        };
    }
  },
};
</script>
<style lang="scss" scoped>
.event__flag {
  max-width: $space-m;
}

.participant__avatar {
  margin-left: calc(-1 * var(--space-xs));
  border: 3px solid $color-neutral-100;
  box-sizing: content-box;
  &:first-child {
    margin-left: 0;
  }
}

.organizer__name {
    flex-shrink: 1;
}
.abuse-link {
  color: inherit;
  text-decoration: underline !important;
}
</style>
